<script setup>
import { useRequestSurveyStore } from "@/stores/requestSurvey";

const requestSurveyStore = useRequestSurveyStore();

const props = defineProps({
  request: {
    type: Object,
    required: true,
  },
  category: {
    type: Object,
    required: false,
  },
});

const beginRequest = () => {
  const category = props.category || {
    name: "wildcard",
  };
  requestSurveyStore.beginRequestSurvey({ ...props.request, category });
};
</script>

<template>
  <button
    :class="[
      'line-clamp-2 text-balance',
      'h-14 w-full cursor-pointer rounded-full px-4 text-base font-bold sm:text-sm',
      'border border-brand-primary-teal-100 hover:border-transparent',
      'bg-brand-primary-teal-50 hover:bg-brand-primary-teal-400',
      'text-brand-primary-teal-700 hover:text-white',
    ]"
    @click="beginRequest"
  >
    {{ request.name }}
  </button>
</template>
